import React from 'react'
import Modal from 'react-modal'
import {injectIntl, defineMessages, FormattedMessage} from 'react-intl'
import moment from 'moment'
import R from 'ramda'

import Icon from './Icon'
import I18nSelect from './I18nSelect'
import CheckBox from './CheckBox'

const customStyles = {
  content : {
    overflow: 'auto',
    top: '25%',
    left: '35%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    width: "500px"
  }
}
const messages = defineMessages({
  onWeekDays: {id: 'onWeek',      defaultMessage: 'on week'},
  onWeekEnds: {id: 'onWeekEnd',   defaultMessage: 'on weekend'},
  allWeek:    {id: 'allWeek',      defaultMessage: 'all week'},
  onWithWeekDayWithList: {id: 'onWithWeekDayWithList', defaultMessage: "on {weekDayList}"},
})

 
class WeekDayPicker extends React.Component {
  shouldComponentUpdate(nextProps){
    return !R.equals(nextProps, this.props)
  }
  render() {
    const {value, isOpen, onToggle, onChange, intl} = this.props
    const timeFormat = {
      weekday: 'long'
    }
    const onChangeWrapped = ({value}) => onChange(value)
    const nbToDate = d => moment().isoWeekday(d)
    const dateToDay = (d) => intl.formatDate(d, timeFormat)
    const dates = R.map(nbToDate, R.range(1, 8))
    const days = R.map(dateToDay, dates)

    const options = [
      {value: '1111111', label: intl.formatMessage(messages.allWeek)},
      {value: '1111100', label: intl.formatMessage(messages.onWeekDays)},
      {value: '0000011', label: intl.formatMessage(messages.onWeekEnds)},
    ]
    const defaultHumanReable = (v) => {
      const asArray = R.splitEvery(1, v)
      const l = asArray.reduce((acc, v, index) => v == "1" ? acc.concat(days[index])  : acc, [])
      return R.join(', ', l)
    }
      
    const humanReable = (value) => {
      switch(value){
        case "1111111": return intl.formatMessage(messages.allWeek)
        case '1111100': return intl.formatMessage(messages.onWeekDays)
        case '0000011': return intl.formatMessage(messages.onWeekEnds)
        default: return intl.formatMessage(messages.onWithWeekDayWithList, {weekDayList: defaultHumanReable(value)})
      }
    }
    
    return <div className="form-group" onClick={onToggle}>
      <div className="input-group">
        <div className="input-group-addon">
          <Icon name="edit"/>
        </div>
        <div className="form-control form-control-static" style={{float: 'inherit'}}>
          <span>{humanReable(value)}</span>
        </div>
      </div>
      
      <Modal isOpen={isOpen} onRequestClose={onToggle}  style={customStyles}>
        <div className="modal-header">
          <button className="close" onClick={onToggle}>
            <Icon name="times"></Icon>
          </button>
          <h4 className="modal-title">
            <FormattedMessage
              id="Frequency"
              defaultMessage="Frequency"/>
          </h4>
        </div>
      
        <div className="modal-body">
        <div className="frequency-container">  
          <div className="frequency-alternative-container">
            <div className="form-group">
                <label>
                <FormattedMessage id={"Use a standard frequency"} defaultMessage={"Use a standard frequency"}/>
                </label>
                <I18nSelect 
                  multi={false}
                  clearable={false}
                  placeholder={<FormattedMessage id="Custom frequency" defaultMessage="Custom frequency"/>}
                  options={options} 
                  value={value}
                  onChange={onChangeWrapped}/>
            </div>
          </div>
          <span style={{textAlign:'center'}}>
            <FormattedMessage id="Or" defaultMessage="Or"/> 
          </span>
          <div className="frequency-alternative-container">          
            <div className="form-group">
              <label>
                <FormattedMessage id={"Define you own frequency"} defaultMessage={"Define you own frequency"}/>
              </label>
              <div className="form-group">
                {days.map((d, index) => 
                  <CheckBox labelClassName="checkbox-inline"
                            label={d} 
                            value={value[index] == '1'} 
                            key={d}
                            onChange={checked => onChange(R.join('', R.update(index, checked ? "1": "0", value)))}/>
                )}
              </div>
                  
            </div>
           </div>
          </div>
          <center>
            <button className="btn btn-default" onClick={onToggle}>
              <FormattedMessage 
                id={"Validate"}
                defaultMessage={'Validate'}/>
            </button>
          </center>
        </div>
      </Modal>
    </div>
  }
}
export default injectIntl(WeekDayPicker)



/** WEBPACK FOOTER **
 ** ./app/components/WeekDayPicker.jsx
 **/